import React, { useCallback, useEffect } from "react";
import useApiHouse from "../api/useApiHouse";
import { useSelector, useDispatch } from "react-redux";
import { initializeHeaderTab } from "../slices/headerSlice";
import { initializeEntryLineDetailTab } from "../slices/entryLineDetailSlice";
import { initializeEntrySummaryTab } from "../slices/entrySummarySlice";
import { getReconFormPayload } from "../api/apiPayloads";
import { setLoader } from "../slices/loaderSlice";

const useGetFormData = () => {
    const [getFormDataApi, {data, isLoading, error}] = useApiHouse();
    const {currentJob: {reconShipmentId}} = useSelector((state) => state.currentJob)
    const dispatch = useDispatch();
    const getFormData = () => {
        getFormDataApi(getReconFormPayload(reconShipmentId));
        dispatch(setLoader({path:"formGlobalLoader", value:true}))
    }
    useEffect(() => {
        if(!isLoading && data){
            dispatch(initializeHeaderTab(data.eventMessage.reconciledEntryHeader));
            dispatch(initializeEntrySummaryTab(data.eventMessage.reconciledEntrySummaries));
            dispatch(initializeEntryLineDetailTab(data.eventMessage.lineItems));
            dispatch(setLoader({path:"formGlobalLoader", value:false}))
        }
    }, [isLoading, data, error])
    return { getFormData };
}
 
export default useGetFormData;